import React, { useState, useRef } from 'react';
import { Input } from 'reactstrap';

const OTPInput = ({ length = 6, onComplete }) => {
  const [otp, setOtp] = useState(new Array(length).fill(''));
  const inputRefs = useRef([]);

  // 初始化 ref array
  if (inputRefs.current.length !== length) {
    inputRefs.current = new Array(length).fill(null).map((_, i) => inputRefs.current[i] || React.createRef());
  }

  const handleChange = (index, value) => {
    // 只允許數字輸入
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // 如果輸入一個數字，自動跳到下一個輸入框
    if (value && index < length - 1) {
      inputRefs.current[index + 1].focus();
    }
    onComplete(newOtp.join(''));
    
  };

  const handleKeyDown = (index, e) => {
    // 處理刪除鍵
    if (e.key === 'Backspace') {
      if (!otp[index] && index > 0) {
        // 如果當前輸入框為空且不是第一個，跳到前一個輸入框
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text').slice(0, length).split('');
    if (pastedData.some(char => !/^\d$/.test(char))) return;

    const newOtp = [...otp];
    pastedData.forEach((value, i) => {
      newOtp[i] = value;
    });
    setOtp(newOtp);

    // 聚焦到最後一個填入的輸入框的下一個
    const focusIndex = Math.min(pastedData.length, length - 1);
    inputRefs.current[focusIndex].focus();

    onComplete(newOtp.join(''));
   
  };

  return (
    <div className="d-flex align-items-center justify-content-center">
      {otp.map((value, index) => (
        <Input
          key={index}
          innerRef={el => inputRefs.current[index] = el}
          value={value}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(index, e)}
          onPaste={handlePaste}
          maxLength={1}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          autoComplete="off"
          // className="text-center mx-1"
          style={{
            width: '38px',
            height: '46px',
            fontSize: '1.0rem',
            padding: '0.2rem',
            textAlign: "center",
            marginLeft: "0.25rem",
            marginRight: "0.25rem",
          }}
        />
      ))}
    </div>
  );
};

export default OTPInput;